import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, styled, Tooltip } from '@mui/material';
import useGameModes from '@hooks/API/useGameModes';
const modeRestrictedGameList = [
    'rocket-league',
    'league_of_legends',
    'madden-25',
    'madden-26',
    'battlefield-6',
];
const StyledImage = styled('img') `
  height: 24px;
  margin: 3px;
`;
const StyledPaper = styled(Paper) `
  display: flex;
  padding: 4px;
`;
const StyledRemainingModesCount = styled('span') `
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.secondary};
  margin-left: 4px;
  display: flex;
  align-items: center;
`;
const TournamentBoxPillGameMode = ({ tournament, noBorder, }) => {
    const gameKey = tournament.score_template.game.game_key;
    const allowedGameModes = tournament.score_template.gameModes.map(({ code }) => `${code}`);
    const { gameModes } = useGameModes(gameKey);
    const availableGameModes = gameModes.filter((gameMode) => allowedGameModes.includes(gameMode.code));
    // Show 1 icon + "+N" badge when more than 1 mode defined
    const displayGameModes = availableGameModes.length > 1 ? availableGameModes.slice(0, 1) : availableGameModes;
    const remainingModesCount = availableGameModes.length > 1 ? availableGameModes.length - 1 : 0;
    if (noBorder) {
        return (_jsxs("div", { children: [displayGameModes.map((gameMode) => (_jsx(Tooltip, { placement: "top", arrow: true, title: gameMode.name, children: _jsx(StyledImage, { src: gameMode.iconUrl, alt: gameMode.name }) }, gameMode.name))), remainingModesCount > 0 && _jsxs(StyledRemainingModesCount, { children: ["+", remainingModesCount] })] }));
    }
    return modeRestrictedGameList.includes(gameKey) ? (_jsxs(StyledPaper, { elevation: 2, children: [displayGameModes.map((gameMode) => (_jsx(Tooltip, { placement: "top", arrow: true, title: gameMode.name, children: _jsx(StyledImage, { src: gameMode.iconUrl, alt: gameMode.name }) }, gameMode.name))), remainingModesCount > 0 && _jsxs(StyledRemainingModesCount, { children: ["+", remainingModesCount] })] })) : (_jsx("div", {}));
};
export default TournamentBoxPillGameMode;
